export const DEFAULT_MESSAGE_TEMPLATE = `🔥 *New Client Alert — Kickoff Form Complete!*

🏢 Business: {{business_legal_name}} ({{business_type}})
🆔 EIN: {{business_ein}}
📍 Address: {{business_address}}
📞 Phone: {{business_phone}}
📧 Email: {{business_email}}
🌐 Website: {{website}}
☎️ Preferred Area Codes: {{area_codes}}

👤 Contact: {{first_name}} {{last_name}}
👥 Project Lead(s): {{team_leads}}
💬 Comm Channels: {{comm_channels}}
✉️ Team Emails: {{team_emails}}
🗓️ Appointments Via: {{appointment_location}}
🔑 Domain Access: {{domain_access}}
📟 Twilio: {{twilio_status}}

🎙️ Greeting: {{greeting_intro}}
🏭 Company Details: {{company_details}}
❓ Qualifying Questions: {{qualifying_questions}}
🛡️ FAQs / Objections: {{faqs_objections}}
📎 Documents: {{documents}}

⏰ Submitted: {{submitted_at}}`;

export const MSG_PLACEHOLDERS = [
  'business_legal_name', 'business_type', 'business_ein', 'business_address',
  'business_phone', 'business_email', 'website', 'area_codes',
  'first_name', 'last_name', 'team_leads', 'comm_channels', 'team_emails',
  'appointment_location', 'domain_access', 'twilio_status',
  'greeting_intro', 'company_details', 'qualifying_questions', 'faqs_objections',
  'documents', 'submitted_at',
];

export const AI_EMPLOYEES_TEMPLATE = `🎬 *New Higgsfield Prompt — {{title}}* ({{source}})

🪝 Hook: {{hook}}
💡 {{concept}}

{{scenes}}

📝 Caption: {{caption}}`;

export const AI_EMP_PLACEHOLDERS = ['title', 'source', 'hook', 'concept', 'scenes', 'caption'];

export const DAILY_REPORT_TEMPLATE = `📋 *End-of-Day Report — {{date}}*
Your AI team completed {{task_count}} task{{plural}} since the last report:

{{task_list}}

{{draft_previews}}

— Voxinity AI Employees · working 24/7`;

export const DAILY_REPORT_PLACEHOLDERS = ['date', 'task_count', 'plural', 'task_list', 'draft_previews'];
